import { PermissionService } from "@/features/audio/interfaces/browser-services.interface";
import { PermissionStatus } from "@/features/audio/types/permission.types";

export class BrowserPermissionService implements PermissionService {
    async queryPermission(name: "notifications" | "microphone"): Promise<PermissionStatus> {
        if (typeof navigator === "undefined" || !navigator.permissions) {
            return "unknown";
        }

        try {
            const result = await navigator.permissions.query({
                name: name as PermissionName,
            });
            return result.state as PermissionStatus;
        } catch {
            return "unknown";
        }
    }

    subscribeToPermissionChanges(
        name: "notifications" | "microphone",
        callback: (state: PermissionStatus) => void
    ): () => void {
        if (typeof navigator === "undefined" || !navigator.permissions) {
            return () => undefined;
        }

        let permissionStatus: globalThis.PermissionStatus | null = null;

        navigator.permissions
            .query({ name: name as PermissionName })
            .then((status) => {
                permissionStatus = status;
                callback(status.state as PermissionStatus);
                status.onchange = () => {
                    callback(status.state as PermissionStatus);
                };
            })
            .catch(() => {
                callback("unknown");
            });

        return () => {
            if (permissionStatus) {
                permissionStatus.onchange = null;
            }
        };
    }

    async requestMicrophonePermission(): Promise<void> {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach((track) => track.stop());
    }

    async requestNotificationPermission(): Promise<void> {
        if (typeof Notification === "undefined") {
            return;
        }

        await Notification.requestPermission();
    }

    async requestSpeakerPermission(): Promise<void> {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach((track) => track.stop());
    }
}

export const browserPermissionService = new BrowserPermissionService();
